export enum WishSellerValidation {
  None = "None",
  Successful = "Successful",
  Failed = "Failed",
}
